export const getDealerOrInternalPersona = () => {
  // @ts-ignore
  const permissions = window?.env?.USER?.permissions;

  if (permissions?.includes("DEALER_PERSONA")) {
    return "DEALER_PERSONA";
  }

  if (permissions?.includes("INTERNAL_PERSONA")) {
    return "INTERNAL_PERSONA";
  }

  throw new Error("Invalid Persona");
};

